<template>
    <div class="account">
        <section class="account-header">
            <div class="container client">
                <div class="client-name">
                    <h4 class="v-content-account-data" v-contentAccountData="{ section: 'Account', removeHtml: true }">
                        Olá
                    </h4>
                    <p>{{ this.user.user.data.nome }}</p>
                </div>
                <div class="client-end">
                    <button class="v-content-account-data" v-contentAccountData="{ section: 'Account', removeHtml: true }" @click="logOut()">Terminar Sessão</button>
                </div>
                <div class="account-nav container">
                    <button @click="toggleCarteira" :class="{ active: isCarteiraActive }" class="v-content-account-data" v-contentAccountData="{ section: 'Account', removeHtml: true }">Carteira</button>
                    <button @click="toggleTransaction" :class="{ active: isTransactionActive }" class="v-content-account-data" v-contentAccountData="{ section: 'Account', removeHtml: true }">Transações</button>
                    <button @click="toggleAccount" :class="{ active: isAccountActive }" class="v-content-account-data" v-contentAccountData="{ section: 'Account', removeHtml: true }">Gestão de conta</button>           
                </div>
            </div>
        </section>
        <section class="account-body">
            <div class="container" v-show="isCarteiraActive">
                <div class="account-body-title col-md-12 v-content-account-data" v-contentAccountData="{ section: 'Account', removeHtml: true }"> 
                    A sua carteira
                </div>
                <div class="row">
                    <div v-if="!this.user.conta_corrente || this.user.conta_corrente.length == 0" class="col-md-12">
                        <p class="v-content-account-data" v-contentAccountData="{ section: 'Account', removeHtml: true }">Não tem transações</p>
                    </div>
                    <div class="col-card col-md-6" v-for="i in this.user.conta_corrente" :key="i.id" v-else>
                        <div class="card" @click="openModal(i.transacoes)">
                            <div class="card-body">
                                <div class="card-body-logoname">
                                    <img v-if="i.img_loja" :src="'https://imgs.app.freebee.pt/redes/' + i.img_loja" alt="">
                                    <img v-else src="@/assets/img/not-found.png" alt="">
                                    <p class="card-text">{{ i.loja }}</p>
                                </div>
                                <div class="card-body-value">
                                    <div>
                                        <p>{{ $t('balance') }}</p>
                                        <h4>{{ i.total }}</h4>
                                    </div>
                                    <div>
                                        <p>{{ $t('points') }}</p>
                                        <h4>{{ i.pontos }}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container" v-show="isTransactionActive">
                <div class="account-body-title v-content-account-data" v-contentAccountData="{ section: 'Account', removeHtml: true }">Transaçõess</div>
                <div v-if="!this.user.transacoes || this.user.transacoes.length == 0" class="col-md-12">
                    <p class="v-content-account-data" v-contentAccountData="{ section: 'Account', removeHtml: true }">Não tem transações 2</p>
                </div>
                <div class="table">
                    <table>
                        <tbody>
                            <tr v-for="v in this.user.transacoes" :key="v.id">
                                <td class="date">{{ v.data }}</td>
                                <td class="name">{{ v.loja }}</td>
                                <td class="points"><span>{{ $t('points') }}</span>{{ v.pontos_actual }}</td>
                                <td class="value"><span>{{ $t('balance') }}</span>{{ v.saldo_actual }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="container" v-show="isAccountActive && !isChangeDataUser && !isChangePassword && !isChangePhone && !isChangeRgpd && !isPortability && !isForget">
                <div class="row">
                    <div class="cursor col-md-4" @click="changeData()">
                        <div class="card">
                            <div class="card-account">
                                <div class="card-account-img">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="53.128" height="52" viewBox="0 0 53.128 52">
                                        <g id="Group_6237" data-name="Group 6237" transform="translate(-1.5 -2)">
                                            <path id="Path_6482" data-name="Path 6482" d="M21.5,2a13,13,0,1,0,13,13A13.006,13.006,0,0,0,21.5,2Zm0,3.714A9.285,9.285,0,1,1,12.214,15,9.288,9.288,0,0,1,21.5,5.714Z" transform="translate(5.999 0)" fill="#e84e0f" fill-rule="evenodd"/>
                                            <path id="Path_6483" data-name="Path 6483" d="M5.214,36.57H28.427a1.857,1.857,0,1,1,0,3.714H3.357A1.858,1.858,0,0,1,1.5,38.427V34.713A16.712,16.712,0,0,1,18.213,18H28.427a1.857,1.857,0,1,1,0,3.714H18.213a13,13,0,0,0-13,13Z" transform="translate(0 13.712)" fill="#e84e0f" fill-rule="evenodd"/>
                                            <path id="Path_6484" data-name="Path 6484" d="M38.546,24.2a1.858,1.858,0,0,0,0-2.626L33.9,16.932a1.858,1.858,0,0,0-2.626,0L20.388,27.823a1.859,1.859,0,0,0-.542,1.233l-.212,4.851a1.857,1.857,0,0,0,1.937,1.935l4.851-.21a1.859,1.859,0,0,0,1.233-.542Zm-15.021,5.74-.091,2.106,2.106-.093,9.066-9.066L32.592,20.87Z" transform="translate(15.539 12.331)" fill="#e84e0f" fill-rule="evenodd"/>
                                            <path id="Path_6485" data-name="Path 6485" d="M19.857,31.716H36.57a1.857,1.857,0,1,0,0-3.714H19.857a1.857,1.857,0,0,0,0,3.714Z" transform="translate(14.141 22.284)" fill="#e84e0f" fill-rule="evenodd"/>
                                        </g>
                                    </svg>
                                </div>
                                <div class="card-account-text">
                                    <div>
                                        <p class="v-content-account-data" v-contentAccountData="{ section: 'Account', removeHtml: true }">alterar123</p>
                                        <h4 class="v-content-account-data" v-contentAccountData="{ section: 'Account', removeHtml: true }">Seus dados123</h4>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="11.019" height="17.46" viewBox="0 0 11.019 17.46">
                                            <path id="Path_6452" data-name="Path 6452" d="M1.175,0h15.11a1.327,1.327,0,0,1,.828,2.228L9.561,10.637a1.094,1.094,0,0,1-1.662,0L.347,2.228A1.327,1.327,0,0,1,1.175,0Z" transform="translate(0 17.46) rotate(-90)" fill="#f15a22"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="cursor col-md-4" @click="changePhone()">
                        <div class="card">
                            <div class="card-account">
                                <div class="card-account-img">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="36.158" height="52" viewBox="0 0 36.158 52">
                                        <path id="mobile" d="M60.927,0H39.232C35.237,0,32,2.91,32,6.5v39c0,3.59,3.237,6.5,7.232,6.5H60.927c3.994,0,7.232-2.91,7.232-6.5V6.5C68.158,2.91,64.915,0,60.927,0Zm3.616,45.5a3.452,3.452,0,0,1-3.616,3.25H39.232a3.452,3.452,0,0,1-3.616-3.25V6.5a3.452,3.452,0,0,1,3.616-3.25H60.927A3.452,3.452,0,0,1,64.542,6.5ZM53.695,40.625H46.463a1.634,1.634,0,1,0,0,3.25h7.232a1.634,1.634,0,1,0,0-3.25Z" transform="translate(-32)" fill="#e84e0f"/>
                                    </svg>
                                </div>
                                <div class="card-account-text">
                                    <div>
                                        <p class="v-content-account-data" v-contentAccountData="{ section: 'Account', removeHtml: true }">Alterar2</p>
                                        <h4 class="v-content-account-data" v-contentAccountData="{ section: 'Account', removeHtml: true }">Telemóvel2</h4>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="11.019" height="17.46" viewBox="0 0 11.019 17.46">
                                            <path id="Path_6452" data-name="Path 6452" d="M1.175,0h15.11a1.327,1.327,0,0,1,.828,2.228L9.561,10.637a1.094,1.094,0,0,1-1.662,0L.347,2.228A1.327,1.327,0,0,1,1.175,0Z" transform="translate(0 17.46) rotate(-90)" fill="#f15a22"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="cursor col-md-4" @click="changePassword()">
                        <div class="card">
                            <div class="card-account">
                                <div class="card-account-img">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52">
                                        <path id="key" d="M34.938,14.625a2.438,2.438,0,1,1,2.438,2.438A2.432,2.432,0,0,1,34.938,14.625ZM34.125,35.75a17.4,17.4,0,0,1-2.834-.223L28.448,38.2a1.906,1.906,0,0,1-1.635.8H22.75v4.063A2.432,2.432,0,0,1,20.313,45.5H16.25v4.063A2.432,2.432,0,0,1,13.813,52H2.438A2.435,2.435,0,0,1,0,49.563v-9.75a2.438,2.438,0,0,1,.714-1.727L16.748,22.059a18.333,18.333,0,0,1-.5-4.184A17.875,17.875,0,1,1,34.125,35.75Zm0-3.25A14.625,14.625,0,1,0,19.5,17.875a22.813,22.813,0,0,0,.315,3.423l.508,1.777L3.25,40.148v8.6H13v-6.5h6.5v-6.5h6.977l3.687-3.7,1.645.264a14.446,14.446,0,0,0,2.316.183Z" fill="#f15a22"/>
                                    </svg>
                                </div>
                                <div class="card-account-text">
                                    <div>
                                        <p class="v-content-account-data" v-contentAccountData="{ section: 'Account', removeHtml: true }">alterar3</p>
                                        <h4 class="v-content-account-data" v-contentAccountData="{ section: 'Account', removeHtml: true }">Palavra-passe3</h4>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="11.019" height="17.46" viewBox="0 0 11.019 17.46">
                                            <path id="Path_6452" data-name="Path 6452" d="M1.175,0h15.11a1.327,1.327,0,0,1,.828,2.228L9.561,10.637a1.094,1.094,0,0,1-1.662,0L.347,2.228A1.327,1.327,0,0,1,1.175,0Z" transform="translate(0 17.46) rotate(-90)" fill="#f15a22"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="cursor col-md-4" @click="changeRGPD()">
                        <div class="card">
                            <div class="card-account">
                                <div class="card-account-img">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="65" height="52" viewBox="0 0 65 52">
                                        <path id="user-lock" d="M58.5,29.25V21.125A8.114,8.114,0,0,0,50.466,13a8.272,8.272,0,0,0-8.216,8.125V29.25a6.5,6.5,0,0,0-6.5,6.5V45.5a6.5,6.5,0,0,0,6.5,6.5H58.5A6.5,6.5,0,0,0,65,45.5V35.75A6.506,6.506,0,0,0,58.5,29.25Zm-13-8.125a4.875,4.875,0,0,1,9.75,0V29.25H45.5ZM61.75,45.5a3.254,3.254,0,0,1-3.25,3.25H42.25A3.254,3.254,0,0,1,39,45.5V35.75a3.254,3.254,0,0,1,3.25-3.25H58.5a3.254,3.254,0,0,1,3.25,3.25ZM50.375,38.188a2.438,2.438,0,1,0,2.438,2.438A2.437,2.437,0,0,0,50.375,38.188ZM22.75,26a13,13,0,1,0-13-13A13,13,0,0,0,22.75,26Zm0-22.75A9.75,9.75,0,1,1,13,13,9.76,9.76,0,0,1,22.75,3.25ZM17.6,34.125H27.9a13.462,13.462,0,0,1,2.814.3,1.505,1.505,0,0,0,1.838-1.693c0-.012,0-.024,0-.036a1.641,1.641,0,0,0-1.321-1.475,15.591,15.591,0,0,0-3.328-.348H17.6A17.593,17.593,0,0,0,0,48.486,3.533,3.533,0,0,0,3.52,52H30.875a1.625,1.625,0,1,0,0-3.25H3.52a.273.273,0,0,1-.27-.274A14.368,14.368,0,0,1,17.6,34.125Z" transform="translate(0)" fill="#e84e0f"/>
                                    </svg>
                                </div>
                                <div class="card-account-text">
                                    <div>
                                        <p class="v-content-account-data" v-contentAccountData="{ section: 'Account', removeHtml: true }">Gerir3</p>
                                        <h4 class="v-content-account-data" v-contentAccountData="{ section: 'Account', removeHtml: true }">Rgpd3</h4>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="11.019" height="17.46" viewBox="0 0 11.019 17.46">
                                            <path id="Path_6452" data-name="Path 6452" d="M1.175,0h15.11a1.327,1.327,0,0,1,.828,2.228L9.561,10.637a1.094,1.094,0,0,1-1.662,0L.347,2.228A1.327,1.327,0,0,1,1.175,0Z" transform="translate(0 17.46) rotate(-90)" fill="#f15a22"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
            <ClientDataChange v-if="isChangeDataUser"/> 
            <ChangePhone v-if="isChangePhone"/>
            <changePassword v-if="isChangePassword"/>
            <div class="change-rgpd container" v-if="isChangeRgpd">
                <div class="change-rgpd-content">
                    <div class="goback backaccount container">
                        <button @click="goBackAccount()">
                            <svg xmlns="http://www.w3.org/2000/svg" width="67" height="25" viewBox="0 0 67 25">
                                <text id="_voltar" data-name="&lt; voltar" transform="translate(0 19)" fill="#aeaeae" font-size="18" font-family="Poppins-Regular, Poppins"><tspan x="0" y="0">&lt; {{ $t('back') }}</tspan></text>
                            </svg>
                        </button>
                    </div>
                    <h1 class="v-content-account-data" v-contentAccountData="{ section: 'Account', removeHtml: true }">RGPD change</h1>
                    <div class="rgpd-buttons">
                        <button @click="portability()" class="v-content-account-data" v-contentAccountData="{ section: 'Account', removeHtml: true }">portabilidade</button>
                        <button @click="forget()" class="v-content-account-data" v-contentAccountData="{ section: 'Account', removeHtml: true }">esquecimento</button>
                    </div>
                </div>
            </div>
            <portability v-if="isPortability"/>
            <forget v-if="isForget"/>
        </section>
        <Transactions ref="transactions"/>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import Transactions from '@/components/modals/Transactions.vue';
import ClientDataChange from './ClientDataChange.vue';
import ChangePhone from './ChangePhone.vue';
import changePassword from './ChangePassword.vue';
import portability from './Portability.vue';
import forget from './Forget.vue';
import axios from 'axios';
import store from "@/store";
import { mapState } from 'vuex';

const allContents = [];
const lang = localStorage.getItem('locale') || 'es';

export default {
  data() {
    return {
    };
  },
    components: {
        Transactions,
        ClientDataChange,
        ChangePhone,
        changePassword,
        portability,
        forget
    },
  computed: {
    ...mapGetters('App', ['user']),
    ...mapState('App', ['loading', 'isChangePassword', 'isChangeDataUser', 'isChangePhone', 'isChangeRgpd', 'isPortability', 'isForget', 'isCarteiraActive', 'isTransactionActive', 'isAccountActive']),
  },
  methods: {
    ...mapActions('App', ['toggleAccount','getUserData', 'setLogout', 'changeData', 'changePhone', 'changePassword', 'changeRGPD', 'portability', 'forget', 'toggleCarteira', 'toggleTransaction', 'toggleAccount']),
    openModal(transactions) {
      this.$refs.transactions.transactions = transactions;
      this.$bvModal.show('modal-transactions');
    },
    goBackAccount() {
        this.toggleAccount();  // Agora 'toggleAccount' é uma ação do Vuex e é chamada corretamente
    },
    fetchUserData() {
      const token = localStorage.getItem('token');
      this.getUserData(token);
    },
    async logOut() {
        await this.setLogout(); // <-- AGUARDA finalizar

        this.$swal.fire({
            icon: 'success',
            timer: 1500,
            showConfirmButton: false
        });

        this.$router.replace('/');
    },
    updateDirectives() {
            const allElements = document.querySelectorAll('.v-content-account-data');
            allContents.splice(0, allContents.length);
            allElements.forEach((el) => {
                const params = el.dataset.params ? JSON.parse(el.dataset.params) : {};
                params.content = el.innerHTML.trim();
                if (!('type' in params)) params.type = 'text';
                params.theme = process.env.VUE_APP_THEME;
                params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
                allContents.push(params);
            });
        },
    },
    created() {
        this.updateDirectives();
    },
    directives: {
        contentAccountData: {
            inserted: async function (el, binding) {
                const allElements = document.querySelectorAll('.v-content-account-data');
                let params = binding.value ? binding.value : {};
                params.content = el.innerHTML.trim();
                if (!('type' in params)) params.type = 'text';
                params.theme = process.env.VUE_APP_THEME;
                params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
                allContents.push(params);

                if (allElements.length == allContents.length) {
                    store.dispatch('App/loading', true);
                    await axios({
                        method: "POST",
                        url: '/api/v1/site/get-all-contents',
                        data: { allContents, lang }
                    })
                    .then(response => response.data)
                    .then((data) => {
                        const allElements = document.querySelectorAll('.v-content-account-data');
                        allContents.forEach((el) => {
                            if (el.type == 'text') {
                                allElements.forEach((el, index) => {
                                    el.innerHTML = data.data[index];
                                });
                            }
                        });
                        store.dispatch('App/loading', false);
                    });
                }
            },
        }
    },

    mounted() {
        this.fetchUserData();
        if(localStorage.getItem('token') == null) {
            this.$router.push('/');
        }
        if(localStorage.getItem('changePassword') == 'true') {
            this.isAccountActive = true;
            this.isCarteiraActive = false;
            this.isTransactionActive = false;
            this.isChangePassword = true;
            this.changePassword();
            localStorage.removeItem('changePassword');
        }
    },
};
</script>

<style lang="scss" scoped>
.cursor {
    cursor: pointer;
}
.account-header {
    margin-top: 150px;
    background-color: white;
    color: #595959;
    padding: 10px 0;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    text-align: left;
    height: 160px;
    .client {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        height: 100%;
        .account-nav{
            overflow-x: auto;     // ✅ habilita scroll horizontal
            overflow-y: hidden;
            white-space: nowrap;  // ✅ impede quebra de linha
            width: 100%;

            padding-bottom: 5px; 
            -webkit-overflow-scrolling: touch;
            position: absolute;
            left: 0;
            bottom: -35px;
            display: flex;
            gap: 30px;
            button {
                width: 250px;
                min-width: 250px;
                height: 50px;
                background-color: #FFDCCE;
                border: none;
                color: #E84E0F;
                border-radius: 7px;
                font-size: 16px;
                font-weight: 500;
                cursor: pointer;
            }
            .active {
                background-color: #f94904;
                color: white;
            }
        }

        .client-name {
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            h4 {
                font-size: 25px;
                font-family: 'Font Regular';
            }
            p {
                font-size: 25px;
                font-family: 'Font Bold';
            }
        }
        .client-end {
            button {
                width: 155px;
                height: 50px;
                background-color: #FFEBEB;
                color: #F15353;
                border: none;
                border-radius: 7px;
                cursor: pointer;
                font-size: 14px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            @media screen and (max-width: 992px) {
                display: none;
            }
        }
    }
}
.account-body {
    background-color: #F5F5F5;
    min-height: 600px;
    padding: 70px 0 100px;
    &-title {
        font-size: 35px;
        font-family: 'Font Bold';
        color: #E84E0F;
        margin-bottom: 50px;
        text-align: left;
    }
    .col-card{
        @media screen and (max-width: 992px) {
            flex: 0 0 100%;
            max-width: 100%;
        }
    }
    .card{
        margin-bottom: 30px;
        &-body{
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 30px;
            padding: 20px;
            background-color: white;
            border-radius: 13px;
            box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
            &-logoname{
                display: flex;
                gap: 30px;
                align-items: flex-start;
                .card-text {
                    font-size: 25px;
                    font-family: 'Font Regular';
                    color: #595959;
                    text-align: left;
                }
                img{
                    max-width: 103px;
                    height: auto;
                    border-radius: 10px;
                }
            }
            &-value{
                display: flex;
                gap: 30px;
                align-content: space-between;
                justify-content: space-between;
                @media screen and (max-width: 767px) {
                    position: absolute;
                    right: 20px;
                    bottom: 15px;
                }
                div{
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;
                    p{
                        font-size: 25px;
                        font-family: 'Font Regular';
                        color: #595959;
                        text-transform: capitalize;
                        @media screen and (max-width: 992px) {
                            font-size: 18px;
                        }
                    }
                    h4{
                        font-size: 25px;
                        font-family: 'Font Bold';
                        color: #E84E0F;
                        @media screen and (max-width: 992px) {
                            font-size: 20px;
                        }
                    }
                }
            }
        }
        &-account{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            gap: 30px;
            padding: 20px;
            background-color: white;
            border-radius: 13px;
            box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
            &-img{
                svg{
                    width: 50px;
                    height: 50px;
                }
            }
            &-text{
                display: flex;
                justify-content: space-between;
                align-items: flex-end;
                width: 100%;
                color: #595959;
                text-align: left;
                p{
                    font-size: 25px;
                    font-family: 'Font Regular';
                }
                h4{
                    font-size: 26px;
                    font-family: 'Font Bold';
                }
            }
        }
    }
    .table{
        table{
            width: 100%;
            border-collapse: collapse;
            tbody{
                tr{
                    @media screen and (max-width: 992px) {
                        display: flex;
                        flex-direction: column;
                        gap: 15px;
                    }
                    td{
                        border:none;
                        font-size: 16px;
                        font-family: 'Font Regular';
                        color: #595959;
                        text-align: left;
                        padding: 25px 0;
                        border-bottom: 2px solid #707070;
                        @media screen and (max-width: 992px) {
                            border-bottom: none;
                            padding: 0!important;
                        }
                    }
                    .date{
                        width: 20%;
                        font-size: 24px;
                        color: #000000;
                        padding-top: 40px!important;
                        @media screen and (max-width: 992px) {
                            width: 100%;
                        }
                    }
                    .name{
                        width: 50%;
                        font-size: 24px;
                        font-family: 'Font Bold';
                        padding-top: 40px;
                        @media screen and (max-width: 992px) {
                            width: 100%;
                            padding-top: 0;
                        }
                    }
                    .points{
                        position: relative;
                        span{
                            font-size: 20px;
                            font-family: 'Font Regular';
                            text-transform: capitalize;
                            color: #CBCFD2;
                            position: absolute;
                            top: 5px;
                            right: 0;
                            @media screen and (max-width: 992px) {
                                left: 0;
                                top: -20px;
                            }   
                        }
                        width: 15%;
                        font-size: 24px;
                        font-family: 'Font Bold';
                        text-align: right;
                        color: #F15C25; 
                        top: 15px;
                        @media screen and (max-width: 992px) {
                            width: 100%;
                            text-align: left;
                        }
                    }
                    .value{
                        position: relative;
                        span{
                            font-size: 20px;
                            font-family: 'Font Regular';
                            text-transform: capitalize;
                            color: #CBCFD2;
                            position: absolute;
                            top: 5px;
                            @media screen and (max-width: 992px) {
                                left: 0;
                                top: -20px;
                            }  
                        }
                        width: 15%;
                        font-size: 24px;
                        font-family: 'Font Bold';
                        text-align: right;
                        color: #F15C25; 
                        top: 15px;
                        @media screen and (max-width: 992px) {
                            width: 100%;
                            text-align: left;
                            padding-bottom: 20px!important;
                            border-bottom: 2px solid #707070;
                        }
                    }
                }
            }
        }
    }
}
.change-rgpd {
    &-content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        gap: 35px;
        @media screen and (max-width: 768px) {
            height: auto;
            gap: 50px;
        }

        h1 {
            font-size: 35px;
            font-family: 'Font Bold';
            color: #E84E0F;
            text-align: left;
        }

        .rgpd-buttons {
            display: flex;
            gap: 30px;
            button {
                width: 328px;
                height: 71px;
                padding: 10px 20px;
                background-color: #FFFFFF;
                color: #000000;
                border: none;
                border-radius: 7px;
                font-size: 20px;
                font-family: 'Font Regular';
                cursor: pointer;
                transition: all 0.3s;
                &:hover {
                    transform: scale(1.1);
                }
            }
        }
    }
    .backaccount{
        padding: 0 0 50px 0;
    }
}
</style>